module.exports = __webpack_public_path__ + "img/features3.694acbc6.png";